import { AuthKitProvider } from "@farcaster/auth-kit";

const FarcasterProvider = ({ children }: { children: React.ReactNode }) => (
  <AuthKitProvider config={{}}>{children}</AuthKitProvider>
);

export default FarcasterProvider;
